(()=>{
'use strict';
if(window.bwOfferMotionReady)return;window.bwOfferMotionReady=true;
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
const buttons=[...document.querySelectorAll('[data-add],[data-sticky-add],[data-shr-sticky-add]')];
const drawer=document.querySelector('#bw-cart');
const visibility=new IntersectionObserver(entries=>entries.forEach(e=>e.target.classList.toggle('bw-offer-in-view',e.isIntersecting)));
const sizes=new ResizeObserver(entries=>entries.forEach(({target:b})=>{if(b.offsetWidth&&b.offsetHeight){b.style.setProperty('--bw-grow-x',1+3/b.offsetWidth);b.style.setProperty('--bw-grow-y',1+3/b.offsetHeight)}}));
buttons.forEach(b=>{b.classList.add('bw-liquid-button');visibility.observe(b);sizes.observe(b)});
function sync(){
 const shr=document.querySelector('[data-shr-product] .shr-offer input:checked');
 const journal=document.querySelector('[data-journal-picker] [name=bw_pack]:checked');
 const best=shr?Number(shr.dataset.shrCount)===3:Number(journal?.value)>=3;
 buttons.forEach(b=>b.classList.toggle('bw-best-offer',best));
}
document.addEventListener('change',e=>{if(e.target.matches('.shr-offer input,[name=bw_pack]'))sync()});sync();
function burst(b,e={}){
 if(reduce.matches)return;
 const box=b.getBoundingClientRect(),ring=document.createElement('span');
 ring.className='bw-add-burst';ring.setAttribute('aria-hidden','true');
 const inside=e.detail&&e.clientX>=box.left&&e.clientX<=box.right&&e.clientY>=box.top&&e.clientY<=box.bottom;
 ring.style.left=((inside?e.clientX:box.left+box.width/2)-24)+'px';ring.style.top=((inside?e.clientY:box.top+box.height/2)-24)+'px';
 for(let n=0;n<8;n++){const p=document.createElement('i'),a=n*Math.PI/4;p.style.setProperty('--dx',Math.cos(a)*20+'px');p.style.setProperty('--dy',Math.sin(a)*20+'px');ring.append(p)}
 document.body.append(ring);setTimeout(()=>ring.remove(),550);
 if(b.matches('[data-add],[data-sticky-add],[data-shr-sticky-add]')){b.classList.add('bw-add-tapped');setTimeout(()=>b.classList.remove('bw-add-tapped'),190);}
}
window.bwTapBurst=burst;
document.addEventListener('click',e=>{const b=e.target.closest('[data-add],[data-sticky-add],[data-shr-sticky-add]');if(b&&!b.disabled)burst(b,e)},true);
let veil;
function clearVeil(){veil?.remove();veil=null;document.body.classList.remove('bw-adding-mobile')}
document.addEventListener('bw:add-start',()=>{
 clearVeil();veil=document.createElement('div');veil.className='bw-add-veil';veil.setAttribute('aria-hidden','true');document.body.append(veil);document.body.classList.add('bw-adding-mobile');
});
document.addEventListener('bw:cart-added',clearVeil);
document.addEventListener('bw:add-end',clearVeil);
if(drawer)new MutationObserver(()=>document.body.classList.toggle('bw-cart-is-open',drawer.open)).observe(drawer,{attributes:true,attributeFilter:['open']});
document.addEventListener('visibilitychange',()=>document.body.classList.toggle('bw-motion-paused',document.hidden));
window.addEventListener('pagehide',clearVeil);
})();
